import type { LanguageCode } from '@sparted/shared-library/business/types';
import { t } from 'i18next';
import React, { useMemo } from 'react';

import SInput from 'Components/structural/SInput/SInput';
import SSelect from 'Components/structural/SSelect/SSelect';
import UButton from 'Components/unit/UButton/UButton';
import { getLanguagesAvailableWithCode } from 'Services/language/languageService';

import styles from './BreakingNewsForm.style';

export type BreakingNewsFormProps = {
  name: string;
  onNameChange: (value: string) => void;
  selectedLanguageCode: LanguageCode | null;
  onLanguageSelect: (value: LanguageCode | null) => void;
  onBack: () => void;
};

export const BreakingNewsForm = ({
  name,
  selectedLanguageCode,
  onLanguageSelect,
  onNameChange,
  onBack,
}: BreakingNewsFormProps) => {
  const availableLanguages = getLanguagesAvailableWithCode();

  const languageSelectItems = useMemo(
    () =>
      availableLanguages.map(({ id, languageName, languageCode }) => ({
        id,
        label: languageName,
        value: languageCode,
      })),
    [availableLanguages],
  );

  const selectedLanguage = languageSelectItems.find(({ value }) => value === selectedLanguageCode);

  return (
    <div style={styles.wrapper}>
      <div style={styles.backButton}>
        <UButton
          text={t('activities:list.breaking_news_form.back')}
          typography="BODY3"
          leftIcon="arrow-left"
          iconSize="small"
          onClick={onBack}
        />
      </div>
      <div style={styles.form}>
        <section style={styles.block}>
          <SInput
            label={t('activities:list.breaking_news_form.name')}
            type="large"
            placeholder={t('activities:list.breaking_news_form.name_placeholder')}
            maxLength={40}
            required
            value={name}
            onChange={onNameChange}
          />
        </section>
        <section style={styles.block}>
          <SSelect
            label={t('activities:list.breaking_news_form.select_language')}
            required
            placeholder={t('activities:list.breaking_news_form.select_language_placeholder')}
            items={languageSelectItems}
            onSelect={(item) => onLanguageSelect(item.value as LanguageCode)}
            selected={selectedLanguage || null}
            style={styles.languageSelect}
          />
          <div style={styles.commentBlock}>
            <p style={styles.notice}>{t('activities:list.breaking_news_form.notice')}</p>
          </div>
        </section>
      </div>
    </div>
  );
};
